module.exports = __webpack_public_path__ + "assets/img/20220902.42944027.png";